export default {
  TO_COMPLETE: [0],
  VERIFYING: [11, 13, 30, 31],
  EXPIRED: [15],
  VALIDATED: [16, 33],
  REFUSED: [12, 14, 32, 34]
}
